import React from "react";
const Terms = (props) => {
  return (
    <section
      id="id_ico_about_section "
      className={`ico_about_section section_space section_decoration bg-white ${props.abClass}`}
    >
      <div className="container">
        <div className="row justify-content-lg-between pt-5">
          <div className="col-lg-12">
            <ul className="list-unstyled">
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                <p className="text-dark fw-semibold opacity-50 mb-0">
                  Effective Date: 10/08/2025
                </p>
                <p className="text-dark fw-semibold opacity-50 mb-0">
                  Company: TopCoin UK. Ltd
                </p>
                <p className="text-dark fw-semibold opacity-50 mb-0">
                  Company Registeration No: 16483297
                </p>
                <p className="text-dark fw-semibold opacity-50 mb-3">
                  Contact: info@topcoinuk.com
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">1. Introduction </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  These Terms & Conditions (“Terms”) govern your use of the
                  Topcoin UK website and wallet services (“Services”). By
                  accessing or using our Services, you agree to be bound by
                  these Terms. Topcoin UK is a customer reward and loyalty
                  platform, not a financial, banking, or investment service.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">2. Eligibility </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  Users under 18 may use the Services with parental or guardian
                  consent. Participation in Topcoin UK is voluntary and for
                  loyalty and rewards purposes only.{" "}
                  <a
                    href="../../../parental_consent_form.pdf"
                    download
                    className=" fw-bold text-decoration-underline text-primary"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {" "}
                    download the Parental/Guardian Consent Form{" "}
                  </a>
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  3. Account Registration
                </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  To use the wallet system, you must provide accurate
                  information including your name and email address. You are
                  responsible for maintaining the confidentiality of your login
                  details.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
              >
                {/* <h5 className="title_text text-dark">4. Wallet & Units </h5> */}
                <h5 className="title_text text-dark">4. Wallet & TopCoin </h5>

                <ul className="text-dark opacity-50">
                  <li>
                    Topcoin UK are digital reward units credited to your wallet
                    when you shop with participating businesses.
                  </li>
                  <li>
                    TopCoin UK has no monetary or exchange value outside the
                    Topcoin UK system and cannot be traded, sold, transferred,
                    or redeemed as currency.
                  </li>
                  <li>
                    Wallet balances and TopCoin totals are tracked internall.
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">5. Use of Services</h5>

                <ul className="text-dark opacity-50">
                  <li>
                    You agree to use the Services lawfully and not for
                    fraudulent or harmful activities.
                  </li>
                  <li>
                    You may not attempt to manipulate the wallet system or
                    TopCoin.
                  </li>
                  <li>
                    Participation is voluntary and not an investment, gambling,
                    or cryptocurrency scheme.
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  6. Businesses & Platform System
                </h5>
                <ul className="text-dark opacity-50">
                  <li>
                    Participating businesses pay for advertising services and for the TopCoin rewards offered to their customers.
                  </li>
                  <li>
                   Businesses operate within the TopCoin UK platform system, where reward activity and transactions are securely recorded to provide transparency and tracking across the network.
                  </li>
                  <li>
                    TopCoin is a loyalty reward within the TopCoin platform and does not represent money, a financial product, or an investment.
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  7. Intellectual Property
                </h5>
                <ul className="text-dark opacity-50">
                  <li>
                    All intellectual property rights related to Topcoin UK
                    branding, software, and content are owned by Topcoin UK ltd.
                  </li>
                  <li>
                    You may not copy, modify, or distribute our materials
                    without prior written consent.
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">8. Privacy</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  Your use of the Services is also governed by our Privacy
                  Policy.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">
                  9. Limitation of Liability
                </h5>

                <ul className="text-dark opacity-50">
                  <li>
                    TopCoin UK Ltd is not liable for any indirect, incidental,
                    or consequential damages arising from the voluntary use of
                    the Services.
                  </li>
                  {/* <li>
                    We do not guarantee wallet balances or future rewards.
                  </li> */}
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">10. Termination</h5>

                <ul className="text-dark opacity-50">
                  <li>
                    We reserve the right to suspend or terminate your access to
                    the Services for violations of these Terms or fraudulent
                    behavior.
                  </li>
                  <li>
                    You may close your wallet account at any time by contacting
                    support.
                  </li>
                </ul>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">11. Changes to Terms </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  We may update these Terms periodically. Updated Terms will be
                  posted on our website. Continued use of the Services after
                  updates means you accept the changes.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">12. Governing Law </h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  These Terms are governed by the laws of the United Kingdom.
                </p>
              </li>
              <li
                data-aos="fade-up"
                data-aos-duration="600"
                data-aos-delay="100"
                className="py-2"
              >
                <h5 className="title_text text-dark">12. Contact Us</h5>
                <p className="info_description text-dark opacity-50 mb-0">
                  For questions or concerns regarding these Terms, please
                  contact:
                </p>
                <ul className="info_description text-dark opacity-50 mb-0">
                  <li>
                    Email: <strong>info@topcoinuk.com</strong>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Terms;
